import * as ACTIONS from './actions.constants';
import { IAction as Action } from '../../models';

/** LOAD */
export function loadActions() {
    return { type: ACTIONS.ACTIONS_LOAD };
}

export function loadActionsSuccess(data: Action[]) {
    return { type: ACTIONS.ACTIONS_LOAD_SUCCESS, payload: data };
}

export function loadActionsError(error: any) {
    return { type: ACTIONS.ACTIONS_LOAD_ERROR, payload: error };
}


/** ADD */
// export function addActions(targetActions: Action[]) {
//     return { type: ACTIONS.ACTIONS_ADD, payload: targetActions };
// }

// export function addActionsSuccess(targetActions: Action[]) {
//     return { type: ACTIONS.ACTIONS_ADD_SUCCESS, payload: targetActions };
// }

// export function addActionsError(error: any) {
//     return { type: ACTIONS.ACTIONS_ADD_ERROR, payload: error };
// }

export function addAction(targetAction: Action) {
    return { type: ACTIONS.ACTION_ADD, payload: targetAction };
}

export function addActionSuccess(targetAction: Action) {
    return { type: ACTIONS.ACTION_ADD_SUCCESS, payload: targetAction };
}

export function addActionError(error: any) {
    return { type: ACTIONS.ACTION_ADD_ERROR, payload: error };
}


/** UPDATE */
// export function updateActions(targetActions: Action[]) {
//     return { type: ACTIONS.ACTIONS_UPDATE, payload: targetActions };
// }

// export function updateActionsSuccess(targetActions: Action[]) {
//     return { type: ACTIONS.ACTIONS_UPDATE_SUCCESS, payload: targetActions };
// }

// export function updateActionsError(error: any) {
//     return { type: ACTIONS.ACTIONS_UPDATE_ERROR, payload: error };
// }

export function updateAction(targetAction: Action) {
    return { type: ACTIONS.ACTION_UPDATE, payload: targetAction };
}

export function updateActionSuccess(targetAction: Action) {
    return { type: ACTIONS.ACTION_UPDATE_SUCCESS, payload: targetAction };
}

export function updateActionError(error: any) {
    return { type: ACTIONS.ACTION_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteActions(guids: string[]) {
    return { type: ACTIONS.ACTIONS_DELETE, payload: guids };
}

export function deleteActionsSuccess(Actions: Action[]) {
    return { type: ACTIONS.ACTIONS_DELETE_SUCCESS, payload: Actions };
}

export function deleteActionsError(error: any) {
    return { type: ACTIONS.ACTIONS_DELETE_ERROR, payload: error };
}

export function deleteAction(guid: string) {
    return { type: ACTIONS.ACTION_DELETE, payload: guid };
}

export function deleteActionSuccess(action: Action) {
    return { type: ACTIONS.ACTION_DELETE_SUCCESS, payload: action };
}

export function deleteActionError(error: any) {
    return { type: ACTIONS.ACTION_DELETE_ERROR, payload: error };
}